import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

function ListGroupItem({ children, className }) {
  return <li className={cx("text-sm", className)}>{children}</li>;
}

ListGroupItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

ListGroupItem.defaultProps = {
  className: "",
};

export default ListGroupItem;
